import React from "react";

const AdditionalExaminations = () => {
  return (
    <>
    {/* to be continued... */}
      <div className="grid grid-cols-3 gap-5 p-5">
        {/* left side part */}
        <div>
          <p className="ml-6">IOP</p>
          <br />
          <input
            type="text"
            className="w-[94%] border border-gray-300 rounded-md p-3 ml-6"
            placeholder="Time"
          />
          <div className="flex my-5">
            <span className="self-center">R:</span>&nbsp;&nbsp;
            <input
              type="text"
              className="w-full border border-gray-300 rounded-md p-3"
              placeholder="Time"
            />
          </div>
          <div className="flex">
            <span className="self-center">L:</span>&nbsp;&nbsp;
            <input
              type="text"
              className="w-full border border-gray-300 rounded-md p-3"
              placeholder="Time"
            />
          </div>
        </div>
        {/* vertical line */}
        <div className="flex justify-center">
          <div className="border-l-2"></div>
        </div>
        {/* right side part */}
        <div className="ml-[-190px] mr-52">
          <p>Drop:</p>
          <br />
          <input
            type="text"
            placeholder="Type here"
            className="w-[82%] ml-[70px] border border-gray-300 rounded-md p-3"
          />
          <div className="flex my-5">
            <span className="self-center">BN:</span>
            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
            <input
              type="text"
              className="w-full border border-gray-300 rounded-md p-3"
              placeholder="Time"
            />
          </div>
          <div className="flex">
            <span className="self-center">Expiry Date:</span>
            <input
              type="date"
              className="w-full border border-gray-300 rounded-md p-3"
              placeholder="Time"
            />
          </div>
        </div>
      </div>
    </>
  );
};

export default AdditionalExaminations;
